import { 
  Heading,
  Box,
  Avatar,
  Stack,
  Text,
  useToast,
  ButtonGroup,
  Divider,
  Wrap,
  WrapItem,
  Flex,
  FormControl,
  ScaleFade,
  Skeleton,
  FormLabel,
  VStack,
  Tag,
  TagLabel,
  TagCloseButton,
  useDisclosure,
  useColorModeValue} from '@chakra-ui/react'
import {
  InputControl,
  SubmitButton,  
} from "formik-chakra-ui";
import { db } from '../../utils/init-firebase';
import { collectionGroup, doc, getDoc, getDocs, orderBy, query, updateDoc, where, setDoc, onSnapshot } from "firebase/firestore";
import { Formik, Field } from 'formik'
import { useState, useEffect, useRef } from 'react'
import { useAuth } from '../../contexts/AuthContext'
import { connectFunctionsEmulator, getFunctions, httpsCallable } from 'firebase/functions';
import { getApp } from 'firebase/app';
import { Select } from 'chakra-react-select';
import { useHistory, useParams } from 'react-router-dom';
import TransactionLog from '../../components/TransactionLog/TransactionLog';
import { useBudget } from './useBudget';
import { states } from '../../assets/allstates';
import DeleteDialog from '../../components/Dialogs/DeleteDialog';
import UserAdminControls from '../../components/Admin/UserAdminControls';

// Convert states to react-select format
const stateOptions = states.map(state => ({
  label: `${state.code} - ${state.name}`,
  value: state.code
}));

const currentYear = new Date().getFullYear(); // Get the current year

export default function Profilepage() {
  const { currentUser, Roles, users, SuperAdmin, MarketingAdmin, branches } = useAuth()
  const [loading, setLoading] = useState(true)
  const [initialValues, setInitivalValues] = useState({})
  const [licensedStates, setLicensedStates] = useState([])
  const [selectedUser, setSelectedUser] = useState()
  const [fullUserDoc, setFullUserDoc] = useState(null)
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [deleteTarget, setDeleteTarget] = useState(null)
  const cancelRef = useRef()


  const [selectedYear, setSelectedYear] = useState(currentYear); // State to hold the selected year
  const firstDayOfYear = new Date(selectedYear, 0, 1); // Get the first day of the selected year
  const lastDayOfYear = new Date(selectedYear, 11, 31); // Get the last day of the selected year

  const { transactions, budget, setBudget } = useBudget(selectedUser, selectedYear)

  const history = useHistory()
  const { id } = useParams()
  // const functions = getFunctions(getApp());
  // connectFunctionsEmulator(functions, "localhost", 9001); 
  // const test = httpsCallable(functions, 'test') 
 
  const toast = useToast()

  const isViewingSelf = selectedUser?.value === currentUser?.uid

  // Live subscription to the viewed user's full document (SuperAdmin only) so the
  // admin controls panel always reflects that user's current permissions.
  useEffect(() => {
    if (!SuperAdmin || !selectedUser?.value) {
      setFullUserDoc(null)
      return
    }
    const unsub = onSnapshot(doc(db, 'users', selectedUser.value), (snap) => {
      if (snap.exists()) {
        setFullUserDoc({ ...snap.data(), uid: snap.id })
      } else {
        setFullUserDoc(null)
      }
    })
    return () => unsub()
  }, [SuperAdmin, selectedUser?.value])

  const handleOpenDelete = (uid, name) => {
    setDeleteTarget({ uid, name })
    onOpen()
  }

  const handleCloseDelete = () => {
    setDeleteTarget(null)
    onClose()
  }

  const handleDeleteUser = async () => {
    try {
      const functionsObj = getFunctions(getApp(), 'us-east1')
      const deactivateUser = httpsCallable(functionsObj, 'deactivateUser')
      await deactivateUser({ uid: deleteTarget.uid })
      toast({
        title: 'User successfully deactivated!',
        description: 'Auth account disabled, sessions revoked, and profile deleted.',
        status: 'success',
        position: 'top',
        duration: 5000,
        isClosable: true
      })
    } catch (err) {
      const message = err?.message || String(err)
      toast({
        title: 'Error deactivating user',
        description: message,
        status: 'error',
        position: 'top',
        duration: 9000,
        isClosable: true
      })
    } finally {
      handleCloseDelete()
    }
  }

  const handleSetUser = (id) => {
    id && (SuperAdmin || MarketingAdmin) && history.push(`/profile/${id}`)
  }

  useEffect(() => {
    if(id && users && (SuperAdmin || MarketingAdmin)){
      let userIndex = users.findIndex((user) => user.value === id)
      if(userIndex > -1){
        setSelectedUser(users[userIndex])
      }
    }
    else setSelectedUser({
      value: currentUser.uid,
      label: currentUser.displayName,
      photoURL: currentUser.photoURL,
      email: currentUser.email,
    })
    
  }, [id])


  useEffect( async () => {
    if(selectedUser){
      try{
        setLoading(true)
        const userRef = doc(db, 'users', selectedUser?.value)
        const docSnap = await getDoc(userRef)
        
        // Also check broker_licenses collection
        const licenseRef = doc(db, 'broker_licenses', selectedUser?.value);
        const licenseSnap = await getDoc(licenseRef);
        
        if (docSnap.exists()) {
          // Merge licensed states from both sources (prioritize user document, fallback to broker_licenses)
          let loadedStates = docSnap.data()?.['Licensed States'] || [];
          if (loadedStates.length === 0 && licenseSnap.exists()) {
            loadedStates = licenseSnap.data()?.states || [];
          }
          setLicensedStates([...loadedStates].sort())

          setInitivalValues({...initialValues, 
            NMLS: docSnap.data().NMLS ? docSnap.data().NMLS : '',
            branch: docSnap.data().Branch ? docSnap.data().Branch : '',
            phoneNo: docSnap.data().phoneNo ? docSnap.data().phoneNo.length > 0 ? docSnap.data().phoneNo[0] : '' : '',
            website: docSnap.data().website ? docSnap.data().website : '',
            jobTitle: docSnap.data().Roles && docSnap.data().Roles[0] ? docSnap.data().Roles[0] : '',
            swagBudget: docSnap.data()?.['Swag Budget'] ? docSnap.data()['Swag Budget'] : ''
          })
        } 

        setLoading(false)
      }
      catch(err){
          toast({
              description: err?.message || String(err),
              status: 'error',
              isClosable: true,
              duration: 5000,
              position: 'top'
          })
      }
  }

  }, [selectedUser])


  // Saves ONLY the contact/profile fields. Licensed states are deliberately
  // excluded — they are managed by saveLicensedStates below, so neither save
  // path can overwrite the other's data with stale form values.
  const onSubmit = async (values) => {
    try{
        const userRef = doc(db, 'users', selectedUser?.value)

        // Fetch existing roles first to prevent overwriting permissions (like CRM Admin, Loan Officer)
        const userDoc = await getDoc(userRef)
        const currentRoles = userDoc.exists() ? (userDoc.data().Roles || []) : []
        
        // Create new roles array: put new job title first for display, preserve others for permissions
        let updatedRoles = [...currentRoles]
        const newJobTitle = values.jobTitle || ""
        
        // Remove the new title if it already exists to avoid duplicates
        updatedRoles = updatedRoles.filter(role => role !== newJobTitle)
        // Add new title to the front
        updatedRoles.unshift(newJobTitle)

        await updateDoc(userRef, {
            NMLS: values.NMLS,
            phoneNo: [values.phoneNo],
            website: values.website,
            Roles: updatedRoles,
            'Swag Budget': values.swagBudget
        })

        toast({
            title: 'Profile Updated!',
            status: 'success',
            isClosable: true,
            duration: 3000,
            position: 'top'
        })
        setBudget(values.swagBudget)
    }
    catch(err){
        toast({
            description: err?.message || String(err),
            status: 'error',
            isClosable: true,
            duration: 5000,
            position: 'top'
        })
    }
  
};

  // Persists the licensed states list (users doc + broker_licenses mirror for
  // the FHL Directory). Takes the new list directly so the write can never
  // depend on stale form state.
  const saveLicensedStates = async (newStates) => {
    const sorted = [...newStates].sort()
    const previous = licensedStates
    setLicensedStates(sorted)
    try{
        const userRef = doc(db, 'users', selectedUser?.value)
        await updateDoc(userRef, {
            'Licensed States': sorted
        })

        const licenseRef = doc(db, 'broker_licenses', selectedUser?.value)
        await setDoc(
          licenseRef,
          {
            states: sorted,
            updatedAt: new Date(),
            updatedBy: currentUser.uid
          },
          { merge: true }
        )

        toast({
            title: 'Licensed states updated!',
            description: 'Synced to the FHL Directory',
            status: 'success',
            isClosable: true,
            duration: 3000,
            position: 'top'
        })
    }
    catch(err){
        setLicensedStates(previous)
        toast({
            description: err?.message || String(err),
            status: 'error',
            isClosable: true,
            duration: 5000,
            position: 'top'
        })
    }
  };

  return (
    <>
        <Flex flexDir={'row'} align='center' justify={'center'}>
        {SuperAdmin && users &&
            <FormControl w='250px'>
                <Select
                    options={users}
                    value={selectedUser}
                    onChange={(e) => handleSetUser(e.value)}
                    placeholder="Select User"
                    closeMenuOnSelect={true}
                    selectedOptionColor="green"
                    classNamePrefix={'user-select'}
                />
            </FormControl>
        }
        </Flex>
      {!loading ? 
      <>

         <ScaleFade in initialScale={'0.9'}>
        <Flex direction='column' gap={4}>

        <Flex flexDir='row' gap={2}>        
          <Box
          p={3}
          boxShadow={'lg'}
          rounded={'md'}
          w='25vw'
          >
                <Flex flexDir='column' spacing={0} align={'center'} mb={5}>
                    <Avatar
                    size={'lg'}
                    src={selectedUser?.photoURL} 
                    alt={selectedUser?.label}
                    css={{
                      border: '2px solid white',
                    }}
                  />
                    {/* <Button onClick={() => test()}>
                        test
                    </Button>  */}
                    <Heading fontSize={'md'} fontWeight={500} fontFamily={'body'}>
                      {selectedUser?.label}
                    </Heading>
                    <Text fontSize='14px' mb='2' color={'gray.500'}>{selectedUser?.email}</Text>
      
                   <Formik
                    initialValues={initialValues}
                    onSubmit={onSubmit}
                    
                    >
                    {({ handleSubmit, values, errors }) => (
                   
                          <Flex
                            as="form"
                            onSubmit={handleSubmit}
                            flexDir='column'
                          >
                            {SuperAdmin &&
                            <>
                              <InputControl size='sm' mb={2} w={'100%'} name="jobTitle" label="Job Title" />
                              <InputControl mb={2} w={'100%'} name="swagBudget" label="Marketing Budget ($)" />
                              </>

                            }
                              <InputControl mb={2} w={'100%'} name="NMLS" label="NMLS" />
                              <InputControl mb={2} w={'100%'} name="phoneNo" label="Phone Number" />
                              <InputControl mb='2' w={'100%'} name="website" label="Website" />

                              <br/>
                            <ButtonGroup mt='2' alignSelf='center'>
                                <SubmitButton size='md'>Save</SubmitButton>
                            </ButtonGroup>
                         
                          </Flex>
                    )}
                    </Formik> 
              </Flex>
        </Box>
        
        {/* Licensed States Section */}
        <Box
          p={4}
          boxShadow={'lg'}
          rounded={'md'}
          w='35vw'
          h='fit-content'
        >
          <Heading size='sm' mb={3}>Licensed States</Heading>
          <VStack align="stretch" spacing={3}>
            {/* State Badges */}
            {licensedStates.length > 0 ? (
              <Wrap spacing={2}>
                {licensedStates.map((stateCode) => (
                  <WrapItem key={stateCode}>
                    <Tag
                      size="md"
                      colorScheme="blue"
                      borderRadius="full"
                    >
                      <TagLabel>{stateCode}</TagLabel>
                      <TagCloseButton 
                        onClick={() => saveLicensedStates(licensedStates.filter(s => s !== stateCode))} 
                      />
                    </Tag>
                  </WrapItem>
                ))}
              </Wrap>
            ) : (
              <Text fontSize="sm" color="gray.500">
                No licensed states added yet
              </Text>
            )}

            {/* Add State Dropdown */}
            <FormControl>
              <FormLabel fontSize="sm">Add State License</FormLabel>
              <Select
                options={stateOptions.filter(option => !licensedStates.includes(option.value))}
                placeholder="Select a state to add..."
                onChange={(selectedOption) => {
                  if (!selectedOption) return;
                  saveLicensedStates([...licensedStates, selectedOption.value]);
                }}
                value={null}
                isClearable={false}
                size="sm"
              />
            </FormControl>
          </VStack>
        </Box>

        <TransactionLog 
          transactions={transactions} 
          title={`${selectedUser.label}'s Marketing Budget`} 
          groupTransactionsByTaskID
          selectedUser={selectedUser}
          budget={budget}
          showUserBudget
          selectedYear={selectedYear}
        />
        </Flex>

        {SuperAdmin && fullUserDoc && (
          <Box mt={2}>
            <Heading size='sm' mb={2}>Admin Controls</Heading>
            <UserAdminControls
              user={fullUserDoc}
              branchOptions={branches || []}
              allowDeactivate={!isViewingSelf}
              onRequestDeactivate={handleOpenDelete}
            />
          </Box>
        )}
        </Flex>
        </ScaleFade>
        </>
        :
        <Flex flexDir='row' mt='2'>        
            <Skeleton borderRadius={'md'} height='80vh' w='22vw' mr='3'></Skeleton>
            <Skeleton borderRadius={'md'} height='80vh' w='60vw'></Skeleton>
          </Flex>
      }

      <DeleteDialog
        handleDelete={handleDeleteUser}
        item="User"
        isOpen={isOpen}
        onOpen={onOpen}
        onClose={handleCloseDelete}
        cancelRef={cancelRef}
        selectedUser={deleteTarget}
      />
      </>

  )
}
